import { Capacitor } from '@capacitor/core';
import { Injectable, Signal, inject } from '@angular/core';
import { MobileUserServiceMigrationDecorator, WebUserServiceMigrationDecorator } from './decorator';
import { UserServiceInterface } from './interface';

@Injectable({
  providedIn: 'root',
})
export class UserFacade implements UserServiceInterface {
  private readonly userService = Capacitor.isNativePlatform()
    ? inject(MobileUserServiceMigrationDecorator)
    : inject(WebUserServiceMigrationDecorator);
  public hasSecondFactor: Signal<boolean | undefined> = this.userService.hasSecondFactor;
  public userSecret: Signal<string | undefined> = this.userService.userSecret;
  public username: Signal<string | undefined> = this.userService.username;

  public getSecondFactor(): Promise<string | null> {
    return this.userService.getSecondFactor();
  }

  public resetSecondFactor(): Promise<void> {
    return this.userService.resetSecondFactor();
  }

  public setSecondFactor(secondFactor: string): Promise<void> {
    if (secondFactor === '') {
      throw new Error('Second factor cannot be empty');
    }
    return this.userService.setSecondFactor(secondFactor);
  }
}
